import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { environment } from 'environments/environment';
import { SESSION_PROVIDER } from './session-provider';

/** Attaches a (refreshed-if-needed) Bearer token to calls to the Checkins API only. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const session = inject(SESSION_PROVIDER);
  return from(session.getValidAccessToken()).pipe(
    // A token we could not obtain is not the same as no session. Sending the request bare would
    // earn a 401, and the error interceptor answers a 401 by redirecting to Identity — so a
    // two-second drop in signal used to navigate a check-in tablet away mid-line. Failing here
    // instead keeps the session and the page intact. Status 0 is the literal truth: no server was
    // spoken to, which is also what makes the screen say "No connection. Try again."
    catchError(() => throwError(() => new HttpErrorResponse({ status: 0, url: req.url }))),
    switchMap(token => {
      const authReq = token !== null
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;
      return next(authReq);
    }),
  );
};
